module.exports = __webpack_public_path__ + "img/zokudu-card-background.bd91eda8.svg";